import { useQuery } from "@tanstack/react-query"

import { listUsers, whoAmI } from "@/services/portalApi"

const userQueryKeys = {
  me: ["me"] as const,
  all: ["users"] as const,
  detail: (id: string) => [...userQueryKeys.all, "detail", id] as const,
  list: (params: { partnerId?: string }) =>
    [...userQueryKeys.all, "list", params] as const,
}

export function useWhoAmI() {
  return useQuery({
    queryKey: userQueryKeys.me,

    staleTime: 1000 * 60 * 5,

    queryFn: whoAmI,
  })
}

export function useUsers(partnerId?: string, name?: string) {
  return useQuery({
    queryKey: userQueryKeys.list({ partnerId }),

    staleTime: 1000 * 60 * 5,

    queryFn: async () => {
      const users = await listUsers(partnerId)

      return users
    },

    select: (users) => {
      // Optional-chained on purpose. listUsers declares
      // Promise<Array<UserKratosIdentity>>, but that is an assertion over an
      // unvalidated axios payload: the handler behind GET /users returns a nil
      // Go slice when no identity matches the org (partnerservice
      // auth/kratosReact.go ListKratosIdentities builds orgIdentities with
      // `var`, not a literal), and a nil slice marshals to JSON null. So this
      // is null, not [], for a partner with no users.
      return users?.filter((user) => {
        if (name) {
          return (
            user.Identity.traits.name.first
              .toLowerCase()
              .includes(name.toLowerCase()) ||
            user.Identity.traits.name.last
              .toLowerCase()
              .includes(name.toLowerCase()) ||
            user.Identity.traits.email
              .toLowerCase()
              .includes(name.toLowerCase())
          )
        }

        // If no filters are provided, return all partners
        return true
      })
    },
  })
}
